var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4.22932 12.2602L11.2293 19.2602C11.4222 19.4477 11.7006 19.5181 11.9595 19.4448C12.2184 19.3715 12.4185 19.1657 12.4845 18.9048C12.5504 18.644 12.4722 18.3677 12.2793 18.1802L6.56932 12.4802L19.7993 12.4802C20.2135 12.4802 20.5493 12.1444 20.5493 11.7302C20.5493 11.316 20.2135 10.9802 19.7993 10.9802L6.57932 10.9802L12.2793 5.28017C12.4223 5.14088 12.5029 4.94976 12.5029 4.75017C12.5029 4.55058 12.4223 4.35946 12.2793 4.22017C12.1415 4.07553 11.9491 3.99566 11.7493 4.00017C11.5503 3.99923 11.3592 4.07853 11.2193 4.22017L4.21932 11.2202C3.92686 11.513 3.92686 11.9874 4.21932 12.2802L4.22932 12.2602Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-Left.fc536a51.svg";
export { ForwardRef as ReactComponent };